import { CHANGE_LANGUAGE } from 'b2b-apps/shop/i18n/redux/actionTypes';
import { ChangeLanguageAction } from 'b2b-apps/shop/i18n/redux/types';
import { LANGUAGE_CODE } from 'b2b-common/core/i18n/consts';

const changeLanguage = (from: LANGUAGE_CODE, to: LANGUAGE_CODE): ChangeLanguageAction => ({
  type: CHANGE_LANGUAGE,
  payload: {
    from,
    to,
  },
});

export { changeLanguage };
